import { inject, Injectable } from '@angular/core';
import { PiIndstillingDatasource } from '@features/pengeinstitutter/pi-indstilling/pi-indstilling.datasource';

@Injectable({
  providedIn: 'root'
})
export class PengeinstitutterIndstillingerService {
  datasource = inject(PiIndstillingDatasource);
}
